// ── Training zones (shared across MonitorTab, ResumenTab, session detail) ─────

export function buildTrainingZones(maxHr, minHr = 55) {
  if (!maxHr || maxHr < 100) return null
  const r = v => Math.round(v)
  const restLimit = Math.max(45, Math.min(65, minHr))
  const lightLimit = Math.max(restLimit + 5, Math.min(85, Math.round(restLimit * 1.3)))
  return [
    // Sub-zonas < umbral (dinámicas según historial)
    { key:'z0a', num:null, name:'Reposo',         short:'Reposo',       desc:'Sistema nervioso parasimpático activo. Recuperación completa.',       lo:0,           hi:restLimit,   color:'var(--text-muted)', bg:'var(--chip-bg)', sub:true },
    { key:'z0b', num:null, name:'Activación leve',short:'Activ. leve',  desc:'Movimiento suave, sin estrés cardiovascular.',                        lo:restLimit,   hi:lightLimit,  color:'var(--text-faint)', bg:'var(--chip-bg)', sub:true },
    { key:'z0c', num:null, name:'Calentamiento',  short:'Calentamiento',desc:'Preparación para el ejercicio. Por debajo del umbral de entrenamiento.',lo:lightLimit,  hi:r(maxHr*.50),color:'var(--text-soft)', bg:'var(--track)', sub:true },
    // Zonas de entrenamiento (% FCmáx) — fondos adaptativos con opacidad suave compatibles con modo noche
    { key:'z1',  num:1,    name:'Z1 — Recuperación',  short:'Z1 Recup.',     desc:'Recuperación activa, oxidación de grasas baja intensidad.',    lo:r(maxHr*.50), hi:r(maxHr*.60), color:'#10b981', bg:'rgba(16, 185, 129, 0.12)' },
    { key:'z2',  num:2,    name:'Z2 — Base aeróbica', short:'Z2 Aeróbico',   desc:'Zona óptima de quema de grasa. Resistencia de base.',          lo:r(maxHr*.60), hi:r(maxHr*.70), color:'#3b82f6', bg:'rgba(59, 130, 246, 0.12)' },
    { key:'z3',  num:3,    name:'Z3 — Umbral',        short:'Z3 Umbral',     desc:'Capacidad cardiovascular general, umbral aeróbico.',           lo:r(maxHr*.70), hi:r(maxHr*.80), color:'#f59e0b', bg:'rgba(245, 158, 11, 0.12)' },
    { key:'z4',  num:4,    name:'Z4 — Láctico',       short:'Z4 Láctico',    desc:'Umbral anaeróbico. El lactato empieza a acumularse.',          lo:r(maxHr*.80), hi:r(maxHr*.90), color:'#f97316', bg:'rgba(249, 115, 22, 0.12)' },
    { key:'z5',  num:5,    name:'Z5 — Máximo',        short:'Z5 Máximo',     desc:'Capacidad anaeróbica máxima. Solo esfuerzos muy cortos.',      lo:r(maxHr*.90), hi:r(maxHr * 1.10), color:'#ef4444', bg:'rgba(239, 68, 68, 0.12)' },
  ]
}

export function getTrainingZone(hr, zones) {
  if (!zones || !hr) return null
  return zones.find(z => hr >= z.lo && hr < z.hi) ?? zones[zones.length - 1]
}

export const stressInfo = (v) => v == null ? { label: 'sin datos', color: 'var(--text-soft)' } : v < 35 ? { label: 'Bajo', color: '#30d158' } : v < 55 ? { label: 'Normal', color: '#007aff' } : v < 75 ? { label: 'Elevado', color: '#ff9f0a' } : { label: 'Alto', color: '#ff453a' }

// ── Analytics ────────────────────────────────────────────────────────────────

export function computeStats(readings) {
  if (!readings.length) return { avg: null, min: null, max: null, count: 0, duration: 0 }
  // Keep only physiologically plausible HR — drops sensor warm-up zeros and noise spikes (e.g. 298 bpm).
  const plausible = readings.map(r => r.hr).filter(h => h >= 25 && h <= 230)
  const valid = plausible.length ? plausible : readings.map(r => r.hr)
  // Loop instead of spread (Math.min(...arr)) to stay safe on very large reading arrays.
  let sum = 0, min = Infinity, max = -Infinity
  for (const h of valid) { sum += h; if (h < min) min = h; if (h > max) max = h }
  return {
    avg:      Math.round(sum / valid.length),
    min,
    max,
    count:    readings.length,
    duration: readings.length > 1
      ? Math.round((readings[readings.length - 1].time - readings[0].time) / 1000)
      : 0,
  }
}
